module.exports = __webpack_public_path__ + "static/MidweekWeddingBrochure-be45592b3b9633077d36422ab3486412.pdf";